import React from 'react'
import { ChecklistItem } from './types'

interface ChecklistViewProps {
  items?: ChecklistItem[]
}

const StatusIcon: React.FC<{ status: ChecklistItem['status'] }> = ({ status }) => {
  if (status === 'done') {
    return (
      <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white">
        <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 111.4-1.4L8.5 12l6.8-6.7a1 1 0 011.4 0z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    )
  }
  if (status === 'in_progress') {
    return (
      <span className="flex h-4 w-4 shrink-0 items-center justify-center">
        <span className="h-3 w-3 animate-spin rounded-full border-2 border-indigo-500 border-t-transparent" />
      </span>
    )
  }
  if (status === 'failed') {
    return (
      <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-red-500 text-white">
        <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M4.3 4.3a1 1 0 011.4 0L10 8.6l4.3-4.3a1 1 0 111.4 1.4L11.4 10l4.3 4.3a1 1 0 01-1.4 1.4L10 11.4l-4.3 4.3a1 1 0 01-1.4-1.4L8.6 10 4.3 5.7a1 1 0 010-1.4z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    )
  }
  return (
    <span className="flex h-4 w-4 shrink-0 items-center justify-center">
      <span className="h-3 w-3 rounded-full border-2 border-gray-300" />
    </span>
  )
}

export const ChecklistView: React.FC<ChecklistViewProps> = ({ items }) => {
  if (!items || items.length === 0) return null

  return (
    <ul className="my-2 space-y-1.5 rounded-md border border-gray-200 bg-gray-50 p-3 text-sm">
      {items.map((item) => {
        const isDone = item.status === 'done'
        return (
          <li key={item.id} className="flex items-center gap-2">
            <StatusIcon status={item.status} />
            <span className={isDone ? 'text-gray-500 line-through' : 'text-gray-800'}>
              {item.text}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
